/**
 * Debug placeholder data for repairs
 * Used when DEBUG_MODE.REPAIRS is enabled
 */

export const debugRepairData = [
  // Active Repairs (2 items)
  {
    id: "debug-active-1",
    title: "Broken Door Lock",
    unitNumber: "3A",
    category: "structural",
    urgency: "high",
    priority: "urgent",
    status: "open",
    description: "Tenant unable to lock front door - security concern",
    estimatedCost: 150,
    actualCost: 0,
    tenantNotes: "Lock mechanism is completely stuck",
    internalNotes: "Security issue - needs immediate attention",
    createdAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    updatedAt: new Date(),
    photos: [],
    documents: [],
  },
  {
    id: "debug-active-2",
    title: "Kitchen Sink P-trap Leak",
    unitNumber: "1B",
    category: "plumbing",
    urgency: "urgent",
    priority: "urgent",
    status: "open",
    description:
      "Water dripping under kitchen sink (P-trap leak). Urgent, not flooding. Access today 2-5pm, permission to enter. Tenant has a cat. Callback: +1-555-123-4567. Ticket ID: RPT-10452.",
    estimatedCost: 350,
    actualCost: 0,
    tenantNotes:
      "Location: kitchen, under the sink. Fixture: sink/P-trap. Severity: urgent (not flooding). Access: today 2-5pm. Permission to enter: yes. Callback: +1-555-123-4567. Pet: cat.",
    internalNotes:
      "Clumse AI created ticket RPT-10452. Landlord notified. Plumber to be contacted.",
    assignedTo: "",
    createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago (matches chat timestamp)
    updatedAt: new Date(),
    photos: [],
    documents: [],
  },

  // Scheduled Repairs (4 items)
  {
    id: "debug-scheduled-1",
    title: "HVAC Maintenance",
    unitNumber: "2C",
    category: "hvac",
    urgency: "medium",
    priority: "normal",
    status: "scheduled",
    description: "Annual HVAC system inspection and filter replacement",
    estimatedCost: 200,
    actualCost: 0,
    scheduledDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000), // 3 days from now
    tenantNotes: "Regular maintenance",
    internalNotes: "Annual service appointment",
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), // 1 week ago
    updatedAt: new Date(),
    photos: [],
    documents: [],
  },
  {
    id: "debug-scheduled-2",
    title: "Plumbing Inspection",
    unitNumber: "4A",
    category: "plumbing",
    urgency: "low",
    priority: "normal",
    status: "scheduled",
    description: "Quarterly plumbing check for leaks and water pressure",
    estimatedCost: 120,
    actualCost: 0,
    scheduledDate: new Date(Date.now() + 5 * 24 * 60 * 60 * 1000), // 5 days from now
    tenantNotes: "Preventive maintenance",
    internalNotes: "Quarterly inspection",
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    updatedAt: new Date(),
    photos: [],
    documents: [],
  },
  {
    id: "debug-scheduled-3",
    title: "Carpet Cleaning",
    unitNumber: "1A",
    category: "other",
    urgency: "low",
    priority: "normal",
    status: "scheduled",
    description: "Deep carpet cleaning after tenant move-out",
    estimatedCost: 300,
    actualCost: 0,
    scheduledDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 1 week from now
    tenantNotes: "Unit turnover cleaning",
    internalNotes: "Preparing for new tenant",
    createdAt: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), // 3 days ago
    updatedAt: new Date(),
    photos: [],
    documents: [],
  },
  {
    id: "debug-scheduled-4",
    title: "Window Screen Repair",
    unitNumber: "3B",
    category: "structural",
    urgency: "low",
    priority: "normal",
    status: "scheduled",
    description: "Replace torn window screens on bedroom windows",
    estimatedCost: 80,
    actualCost: 0,
    scheduledDate: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000), // 10 days from now
    tenantNotes: "Screens have holes",
    internalNotes: "Weather damage repair",
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000), // 4 days ago
    updatedAt: new Date(),
    photos: [],
    documents: [],
  },

  // Completed Repairs (6 items)
  {
    id: "debug-completed-1",
    title: "Light Fixture Replacement",
    unitNumber: "2A",
    category: "electrical",
    urgency: "medium",
    priority: "normal",
    status: "completed",
    description: "Replaced broken ceiling light in living room",
    estimatedCost: 120,
    actualCost: 110,
    completedDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    tenantNotes: "Light was flickering",
    internalNotes: "Replaced with LED fixture",
    createdAt: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000), // 5 days ago
    updatedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    photos: [],
    documents: [],
  },
  {
    id: "debug-completed-2",
    title: "Toilet Repair",
    unitNumber: "1C",
    category: "plumbing",
    urgency: "medium",
    priority: "normal",
    status: "completed",
    description: "Fixed running toilet and replaced flapper valve",
    estimatedCost: 75,
    actualCost: 65,
    completedDate: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000), // 4 days ago
    tenantNotes: "Toilet kept running",
    internalNotes: "Simple flapper replacement",
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000), // 6 days ago
    updatedAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000),
    photos: [],
    documents: [],
  },
  {
    id: "debug-completed-3",
    title: "Smoke Detector Battery",
    unitNumber: "3C",
    category: "electrical",
    urgency: "high",
    priority: "high",
    status: "completed",
    description: "Replaced dead smoke detector batteries",
    estimatedCost: 25,
    actualCost: 20,
    completedDate: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000), // 6 days ago
    tenantNotes: "Beeping sound from detector",
    internalNotes: "Safety compliance - completed same day",
    createdAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000), // 6 days ago
    updatedAt: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
    photos: [],
    documents: [],
  },
  {
    id: "debug-completed-4",
    title: "Garbage Disposal Fix",
    unitNumber: "2B",
    category: "appliances",
    urgency: "medium",
    priority: "normal",
    status: "completed",
    description: "Cleared jammed garbage disposal unit",
    estimatedCost: 100,
    actualCost: 85,
    completedDate: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000), // 8 days ago
    tenantNotes: "Disposal making grinding noise",
    internalNotes: "Cleared blockage, unit working properly",
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000), // 10 days ago
    updatedAt: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000),
    photos: [],
    documents: [],
  },
  {
    id: "debug-completed-5",
    title: "Door Hinge Lubrication",
    unitNumber: "4B",
    category: "structural",
    urgency: "low",
    priority: "normal",
    status: "completed",
    description: "Lubricated squeaky bedroom door hinges",
    estimatedCost: 30,
    actualCost: 25,
    completedDate: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000), // 10 days ago
    tenantNotes: "Door squeaking loudly",
    internalNotes: "Quick fix with WD-40",
    createdAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000), // 12 days ago
    updatedAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
    photos: [],
    documents: [],
  },
  {
    id: "debug-completed-6",
    title: "Thermostat Calibration",
    unitNumber: "1D",
    category: "hvac",
    urgency: "medium",
    priority: "normal",
    status: "completed",
    description: "Calibrated thermostat for accurate temperature control",
    estimatedCost: 90,
    actualCost: 90,
    completedDate: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000), // 12 days ago
    tenantNotes: "Temperature readings seem off",
    internalNotes: "Calibrated to match actual room temperature",
    createdAt: new Date(Date.now() - 14 * 24 * 60 * 60 * 1000), // 14 days ago
    updatedAt: new Date(Date.now() - 12 * 24 * 60 * 60 * 1000),
    photos: [],
    documents: [],
  },
];

/**
 * Get debug repair data filtered by status
 */
export const getDebugRepairsByStatus = (status) => {
  return debugRepairData.filter((repair) => {
    if (status === "active") {
      return repair.status === "open" || repair.status === "in_progress";
    }
    return repair.status === status;
  });
};

/**
 * Get all debug repair data
 */
export const getAllDebugRepairs = () => {
  return debugRepairData;
};

// AI Automation Dashboard Debug Data
export const debugAutomationStats = {
  messagesSent: 47,
  remindersSent: 23,
  maintenanceRequests: 8,
  lateFeesApplied: 3,
  depositsProcessed: 12,
  screeningCompleted: 5,
  totalTimeSaved: 420, // 7 hours in minutes
  timeSavedBreakdown: {
    "Rent Reminders": 180,
    "Maintenance Coordination": 120,
    "Late Fee Processing": 60,
    "Deposit Processing": 45,
    Screening: 15,
  },
};

export const debugRecentActions = [
  {
    id: "repair_auto_001",
    actionData: {
      actionType: "repair_ticket_created",
      actualCompletion: "2025-01-15T14:30:25.123Z",
      triggeredBy: "tenant_message_analysis",
    },
    aiContext: {
      confidence: 0.95,
      triggeredBy: "tenant_message",
      createdAt: "2025-01-15T14:30:24.856Z",
      description:
        "Repair ticket created for kitchen sink leak reported by tenant",
      entityId: "tenant_abc123",
      entityName: "Sarah Johnson",
      entityType: "tenant",
      ownerId: "landlord_xyz789",
      priority: "medium",
      propertyAddress: "123 Main Street, Unit 2A",
    },
    result: {
      data: {
        repairTicketId: "repair_ticket_456",
        title: "Kitchen Sink Leak",
        description:
          "Tenant reports water leaking from under kitchen sink, causing water damage to cabinet",
        category: "plumbing",
        priority: "medium",
        location: "Kitchen",
        status: "reported",
        tenantId: "tenant_abc123",
        unitId: "unit_2a",
        landlordId: "landlord_xyz789",
        createdAt: "2025-01-15T14:30:25.123Z",
        aiSummary: "Kitchen sink leak detected from tenant message analysis",
        suggestedActions: [
          "Inspect under-sink plumbing",
          "Check for water damage",
          "Schedule plumber if needed",
        ],
        success: true,
        message: "Repair ticket created successfully for kitchen sink leak",
      },
    },
    // Processed fields for frontend display
    type: "repair_ticket_created",
    action: "Repair ticket created for kitchen sink leak in Unit 2A",
    mobileAction: "Repair ticket created",
    tenant: "Sarah Johnson",
    unit: "Unit 2A",
    time: "2 hours ago",
    status: "completed",
    icon: "ToolOutlined",
    details: { category: "plumbing", priority: "medium" },
    timeSaved: 25,
  },
  {
    id: "rent_reminder_002",
    actionData: {
      actionType: "rent_reminder_sent",
      actualCompletion: "2025-01-15T09:00:00.000Z",
      triggeredBy: "scheduled_automation",
    },
    aiContext: {
      confidence: 0.98,
      triggeredBy: "scheduled_cron",
      createdAt: "2025-01-15T08:59:45.234Z",
      description:
        "Rent reminder sent to Melanie Booth for $1350.00 due on 02/01/2025",
      entityId: "tenant_melanie_123",
      entityName: "Melanie Booth",
      entityType: "tenant",
      ownerId: "landlord_qhy789",
      priority: "medium",
      propertyAddress: "456 Oak Avenue, Unit 1",
    },
    result: {
      data: {
        daysUntilDue: 9,
        deliveryMethods: ["email"],
        dueDate: "2025-02-01T05:00:00.000Z",
        emailSent: true,
        pushSent: false,
        rentAmount: 1350,
        smsSent: false,
        message: "Rent reminder sent successfully to Melanie Booth",
        success: true,
        status: "completed",
        title: "Sent rent reminder to Melanie Booth",
        triggeredAt: "2025-01-15T08:59:45.234Z",
        unitIdentifier: "1",
        updatedAt: "2025-01-15T09:00:00.000Z",
      },
    },
    type: "rent_reminder_sent",
    action: "Rent reminder sent to Melanie Booth for $1,350 due February 1st",
    mobileAction: "Rent reminder sent",
    tenant: "Melanie Booth",
    unit: "Unit 1",
    time: "4 hours ago",
    status: "completed",
    icon: "MessageOutlined",
    details: { amount: 1350, dueDate: "2025-02-01" },
    timeSaved: 15,
  },
  {
    id: "emergency_repair_003",
    actionData: {
      actionType: "emergency_repair_detected",
      actualCompletion: "2025-01-15T16:45:12.789Z",
      triggeredBy: "tenant_message_analysis",
    },
    aiContext: {
      confidence: 0.99,
      triggeredBy: "tenant_message",
      createdAt: "2025-01-15T16:45:11.456Z",
      description: "Emergency repair detected: Gas leak reported by tenant",
      entityId: "tenant_emergency_456",
      entityName: "Mike Rodriguez",
      entityType: "tenant",
      ownerId: "landlord_emergency_789",
      priority: "emergency",
      propertyAddress: "789 Pine Street, Unit 3B",
    },
    result: {
      data: {
        repairTicketId: "emergency_repair_789",
        title: "GAS LEAK - EMERGENCY",
        description:
          "Tenant reports strong gas smell in kitchen, potential gas leak",
        category: "safety",
        priority: "emergency",
        location: "Kitchen",
        status: "reported",
        tenantId: "tenant_emergency_456",
        unitId: "unit_3b",
        landlordId: "landlord_emergency_789",
        createdAt: "2025-01-15T16:45:12.789Z",
        aiSummary: "CRITICAL: Gas leak detected from tenant message",
        suggestedActions: [
          "EVACUATE IMMEDIATELY",
          "Call gas company emergency line",
          "Contact fire department",
          "Do not use electrical switches",
          "Ventilate area if safe to do so",
        ],
        emergencyContacted: true,
        gasCompanyNotified: true,
        success: true,
        message:
          "Emergency repair ticket created and emergency services notified",
      },
    },
    type: "emergency_repair_detected",
    action:
      "EMERGENCY: Gas leak detected in Unit 3B - Emergency services notified",
    mobileAction: "Emergency detected",
    tenant: "Mike Rodriguez",
    unit: "Unit 3B",
    time: "6 hours ago",
    status: "completed",
    icon: "ExclamationCircleOutlined",
    details: { priority: "emergency", category: "safety" },
    timeSaved: 45,
  },
  {
    id: "lease_renewal_004",
    actionData: {
      actionType: "lease_renewal_reminder",
      actualCompletion: "2025-01-15T10:30:00.000Z",
      triggeredBy: "scheduled_automation",
    },
    aiContext: {
      confidence: 0.92,
      triggeredBy: "scheduled_cron",
      createdAt: "2025-01-15T10:29:30.123Z",
      description:
        "Lease renewal reminder sent to tenant 60 days before expiration",
      entityId: "tenant_renewal_789",
      entityName: "Jennifer Lee",
      entityType: "tenant",
      ownerId: "landlord_renewal_123",
      priority: "low",
      propertyAddress: "321 Elm Street, Unit 4C",
    },
    result: {
      data: {
        leaseExpirationDate: "2025-03-15T00:00:00.000Z",
        daysUntilExpiration: 60,
        currentRentAmount: 1200,
        suggestedRenewalAmount: 1250,
        marketAnalysis: {
          currentMarketRate: 1300,
          recommendation: "increase_rent",
          confidence: 0.85,
        },
        deliveryMethods: ["email"],
        emailSent: true,
        success: true,
        status: "completed",
        title: "Lease renewal reminder sent to Jennifer Lee",
        message: "Lease renewal reminder sent successfully",
      },
    },
    type: "lease_renewal_reminder",
    action:
      "Lease renewal reminder sent to Jennifer Lee - Current rent $1,200, suggested $1,250",
    mobileAction: "Lease reminder sent",
    tenant: "Jennifer Lee",
    unit: "Unit 4C",
    time: "1 day ago",
    status: "completed",
    icon: "CalendarOutlined",
    details: { currentRent: 1200, suggestedRent: 1250 },
    timeSaved: 20,
  },
  {
    id: "maintenance_schedule_005",
    actionData: {
      actionType: "maintenance_scheduled",
      actualCompletion: "2025-01-15T11:15:30.456Z",
      triggeredBy: "repair_ticket_analysis",
    },
    aiContext: {
      confidence: 0.88,
      triggeredBy: "repair_ticket_created",
      createdAt: "2025-01-15T11:15:29.789Z",
      description: "HVAC maintenance scheduled based on repair ticket analysis",
      entityId: "repair_ticket_hvac_123",
      entityName: "HVAC System",
      entityType: "repair_ticket",
      ownerId: "landlord_maintenance_456",
      priority: "medium",
      propertyAddress: "654 Maple Drive, Unit 5A",
    },
    result: {
      data: {
        maintenanceType: "hvac_inspection",
        scheduledDate: "2025-01-20T09:00:00.000Z",
        contractorId: "contractor_hvac_789",
        contractorName: "ABC Heating & Cooling",
        estimatedDuration: "2 hours",
        estimatedCost: 150,
        repairTicketId: "repair_ticket_hvac_123",
        tenantNotified: true,
        landlordNotified: true,
        success: true,
        status: "scheduled",
        title: "HVAC maintenance scheduled for Unit 5A",
        message: "Maintenance appointment scheduled successfully",
      },
    },
    type: "maintenance_scheduled",
    action: "HVAC maintenance scheduled for Unit 5A with ABC Heating & Cooling",
    mobileAction: "Maintenance scheduled",
    tenant: "Robert Smith",
    unit: "Unit 5A",
    time: "1 day ago",
    status: "completed",
    icon: "ToolOutlined",
    details: { contractor: "ABC Heating & Cooling", cost: 150 },
    timeSaved: 35,
  },
  {
    id: "payment_processing_006",
    actionData: {
      actionType: "payment_processed",
      actualCompletion: "2025-01-15T13:22:15.678Z",
      triggeredBy: "stripe_webhook",
    },
    aiContext: {
      confidence: 0.99,
      triggeredBy: "stripe_webhook",
      createdAt: "2025-01-15T13:22:14.234Z",
      description: "Rent payment processed automatically via Stripe",
      entityId: "tenant_payment_456",
      entityName: "David Chen",
      entityType: "tenant",
      ownerId: "landlord_payment_789",
      priority: "high",
      propertyAddress: "987 Cedar Lane, Unit 6B",
    },
    result: {
      data: {
        paymentId: "payment_stripe_123",
        amount: 1400,
        currency: "USD",
        paymentMethod: "card",
        stripeChargeId: "ch_1234567890",
        status: "succeeded",
        processedAt: "2025-01-15T13:22:15.678Z",
        tenantId: "tenant_payment_456",
        unitId: "unit_6b",
        landlordId: "landlord_payment_789",
        rentPeriod: "2025-02",
        confirmationEmailSent: true,
        receiptGenerated: true,
        success: true,
        title: "Rent payment processed for David Chen",
        message: "Payment processed successfully via Stripe",
      },
    },
    type: "payment_processed",
    action:
      "Rent payment of $1,400 processed automatically for David Chen via Stripe",
    mobileAction: "Payment processed",
    tenant: "David Chen",
    unit: "Unit 6B",
    time: "2 days ago",
    status: "completed",
    icon: "DollarOutlined",
    details: { amount: 1400, method: "card" },
    timeSaved: 30,
  },
  {
    id: "market_analysis_007",
    actionData: {
      actionType: "market_analysis_generated",
      actualCompletion: "2025-01-15T08:00:00.000Z",
      triggeredBy: "scheduled_automation",
    },
    aiContext: {
      confidence: 0.94,
      triggeredBy: "scheduled_cron",
      createdAt: "2025-01-15T07:59:30.123Z",
      description: "Monthly market analysis generated for property portfolio",
      entityId: "landlord_analysis_123",
      entityName: "Property Portfolio",
      entityType: "landlord",
      ownerId: "landlord_analysis_123",
      priority: "low",
      propertyAddress: "Multiple Properties",
    },
    result: {
      data: {
        analysisPeriod: "2025-01",
        propertiesAnalyzed: 15,
        totalUnits: 45,
        occupancyRate: 0.96,
        averageRent: 1250,
        marketTrends: {
          rentGrowth: 0.05,
          occupancyTrend: "stable",
          marketDemand: "high",
        },
        recommendations: [
          "Consider 3% rent increase for units 1-5",
          "Market rate suggests $50 increase for units 6-10",
          "Maintain current rates for units 11-15",
        ],
        reportGenerated: true,
        emailSent: true,
        success: true,
        status: "completed",
        title: "Monthly market analysis completed",
        message: "Market analysis report generated and sent",
      },
    },
    type: "market_analysis_generated",
    action:
      "Monthly market analysis completed - 96% occupancy, 5% rent growth recommended",
    mobileAction: "Market analysis",
    tenant: "Portfolio Analysis",
    unit: "15 Properties",
    time: "3 days ago",
    status: "completed",
    icon: "BarChartOutlined",
    details: { occupancy: "96%", rentGrowth: "5%" },
    timeSaved: 120,
  },
  {
    id: "tenant_communication_008",
    actionData: {
      actionType: "tenant_communication_sent",
      actualCompletion: "2025-01-15T15:30:45.789Z",
      triggeredBy: "ai_response_generation",
    },
    aiContext: {
      confidence: 0.91,
      triggeredBy: "tenant_message",
      createdAt: "2025-01-15T15:30:44.456Z",
      description:
        "AI-generated response sent to tenant regarding maintenance question",
      entityId: "tenant_comm_789",
      entityName: "Lisa Wang",
      entityType: "tenant",
      ownerId: "landlord_comm_456",
      priority: "medium",
      propertyAddress: "147 Birch Street, Unit 7A",
    },
    result: {
      data: {
        communicationType: "ai_response",
        messageType: "maintenance_guidance",
        responseText:
          "I understand you're having issues with your garbage disposal. I've created a repair ticket for you and your landlord will be notified. In the meantime, please avoid using the disposal and I'll keep you updated on the repair progress.",
        repairTicketId: "repair_ticket_disposal_123",
        tenantId: "tenant_comm_789",
        conversationId: "conv_tenant_landlord_456",
        aiModel: "claude-3-5-sonnet-20241022",
        responseTime: 1.2,
        success: true,
        status: "sent",
        title: "AI response sent to Lisa Wang",
        message: "Communication sent successfully",
      },
    },
    type: "tenant_communication_sent",
    action:
      "AI response sent to Lisa Wang regarding garbage disposal issue - Repair ticket created",
    mobileAction: "AI response sent",
    tenant: "Lisa Wang",
    unit: "Unit 7A",
    time: "3 days ago",
    status: "completed",
    icon: "MessageOutlined",
    details: { aiModel: "Claude 3.5", responseTime: "1.2s" },
    timeSaved: 15,
  },
  {
    id: "late_fee_009",
    actionData: {
      actionType: "late_fee_applied",
      actualCompletion: "2025-01-15T12:00:00.000Z",
      triggeredBy: "scheduled_automation",
    },
    aiContext: {
      confidence: 0.97,
      triggeredBy: "scheduled_cron",
      createdAt: "2025-01-15T11:59:30.123Z",
      description: "Late fee automatically applied to overdue rent payment",
      entityId: "tenant_late_456",
      entityName: "Emily Rodriguez",
      entityType: "tenant",
      ownerId: "landlord_late_789",
      priority: "high",
      propertyAddress: "258 Spruce Avenue, Unit 8B",
    },
    result: {
      data: {
        lateFeeAmount: 75,
        daysOverdue: 7,
        originalRentAmount: 1300,
        totalAmount: 1375,
        tenantId: "tenant_late_456",
        unitId: "unit_8b",
        landlordId: "landlord_late_789",
        rentPeriod: "2025-01",
        notificationSent: true,
        success: true,
        status: "applied",
        title: "Late fee applied to Emily Rodriguez",
        message: "Late fee of $75 applied for 7 days overdue",
      },
    },
    type: "late_fee_applied",
    action:
      "Late fee of $75 applied to Emily Rodriguez - Payment was 7 days overdue",
    mobileAction: "Late fee applied",
    tenant: "Emily Rodriguez",
    unit: "Unit 8B",
    time: "4 days ago",
    status: "completed",
    icon: "DollarOutlined",
    details: { amount: 75, daysOverdue: 7 },
    timeSaved: 20,
  },
  {
    id: "deposit_processing_010",
    actionData: {
      actionType: "deposit_processed",
      actualCompletion: "2025-01-15T14:15:30.456Z",
      triggeredBy: "manual_trigger",
    },
    aiContext: {
      confidence: 0.99,
      triggeredBy: "manual_trigger",
      createdAt: "2025-01-15T14:15:29.789Z",
      description: "Security deposit processed for new tenant move-in",
      entityId: "tenant_deposit_123",
      entityName: "Michael Torres",
      entityType: "tenant",
      ownerId: "landlord_deposit_456",
      priority: "high",
      propertyAddress: "369 Willow Street, Unit 9C",
    },
    result: {
      data: {
        depositAmount: 1500,
        depositType: "security",
        tenantId: "tenant_deposit_123",
        unitId: "unit_9c",
        landlordId: "landlord_deposit_456",
        moveInDate: "2025-01-20T00:00:00.000Z",
        paymentMethod: "bank_transfer",
        receiptGenerated: true,
        success: true,
        status: "processed",
        title: "Security deposit processed for Michael Torres",
        message: "Security deposit of $1,500 processed successfully",
      },
    },
    type: "deposit_processed",
    action:
      "Security deposit of $1,500 processed for Michael Torres - Move-in scheduled for January 20th",
    mobileAction: "Deposit processed",
    tenant: "Michael Torres",
    unit: "Unit 9C",
    time: "5 days ago",
    status: "completed",
    icon: "BankOutlined",
    details: { amount: 1500, moveInDate: "2025-01-20" },
    timeSaved: 25,
  },
];

export const debugAIInsights = [
  {
    id: "debug-insight-1",
    type: "rent_collection",
    title: "Rent Collection Optimization",
    description:
      "3 tenants consistently pay 2-3 days late. Consider sending reminders 2 days before due date instead of on due date.",
    priority: "medium",
    suggestedAction: "Adjust reminder timing for Units 2A, 3C, and 4B",
    icon: "DollarOutlined",
    timeSaved: 30,
    confidence: 0.87,
    triggeredBy: "payment_pattern_analysis",
    entities: ["Sarah Johnson", "Emily Rodriguez", "Jennifer Lee"],
  },
  {
    id: "debug-insight-2",
    type: "maintenance_prediction",
    title: "Preventive Maintenance Alert",
    description:
      "Unit 1B water heater is 8 years old. Schedule annual inspection to prevent emergency repairs.",
    priority: "high",
    suggestedAction: "Schedule water heater inspection for Unit 1B",
    icon: "ToolOutlined",
    timeSaved: 120,
    confidence: 0.94,
    triggeredBy: "equipment_age_analysis",
    entities: ["Melanie Booth", "HVAC System"],
  },
  {
    id: "debug-insight-3",
    type: "tenant_retention",
    title: "Tenant Satisfaction Opportunity",
    description:
      "Unit 2C tenant has been with you for 3 years. Consider offering lease renewal incentives.",
    priority: "low",
    suggestedAction: "Send lease renewal offer with 5% rent increase",
    icon: "UserOutlined",
    timeSaved: 45,
    confidence: 0.82,
    triggeredBy: "tenancy_duration_analysis",
    entities: ["Lisa Wang"],
  },
  {
    id: "debug-insight-4",
    type: "market_analysis",
    title: "Market Rate Adjustment",
    description:
      "Current market rates suggest 8% rent increase potential across 12 units. Market demand is high.",
    priority: "medium",
    suggestedAction: "Implement gradual rent increases over 6 months",
    icon: "BarChartOutlined",
    timeSaved: 90,
    confidence: 0.91,
    triggeredBy: "market_data_analysis",
    entities: ["Property Portfolio"],
  },
  {
    id: "debug-insight-5",
    type: "emergency_prevention",
    title: "Safety System Check",
    description:
      "Gas leak incident in Unit 3B indicates need for annual safety inspections across all units.",
    priority: "high",
    suggestedAction: "Schedule comprehensive safety inspection for all units",
    icon: "SafetyOutlined",
    timeSaved: 180,
    confidence: 0.96,
    triggeredBy: "safety_incident_analysis",
    entities: ["Mike Rodriguez", "Safety Systems"],
  },
];

/**
 * Get debug automation stats
 */
export const getDebugAutomationStats = () => {
  return debugAutomationStats;
};

/**
 * Get debug recent actions
 */
export const getDebugRecentActions = () => {
  return debugRecentActions;
};

/**
 * Get debug AI insights
 */
export const getDebugAIInsights = () => {
  return debugAIInsights;
};

// ============================================================================
// MARKETING LISTINGS DEBUG DATA
// ============================================================================

// Base unit templates for generating variable counts
const baseUnitTemplates = [
  {
    address: "123 Main Street",
    city: "Columbus",
    state: "OH",
    zip: "43215",
    bedrooms: 2,
    bathrooms: 1,
    sqft: 950,
    currentRent: 1200,
    baseRent: 1200,
    securityDeposit: 1800,
    petsAllowed: true,
    amenities: ["Parking", "Laundry", "Dishwasher"],
    description: "Beautiful 2-bedroom apartment in downtown Columbus",
  },
  {
    address: "456 Oak Avenue",
    city: "Columbus",
    state: "OH",
    zip: "43210",
    bedrooms: 3,
    bathrooms: 2,
    sqft: 1400,
    currentRent: 1650,
    baseRent: 1650,
    securityDeposit: 2475,
    petsAllowed: false,
    amenities: [
      "Parking",
      "Laundry",
      "Dishwasher",
      "Air Conditioning",
      "Balcony",
    ],
    description: "Spacious 3-bedroom with modern amenities",
  },
  {
    address: "789 Pine Street",
    city: "Columbus",
    state: "OH",
    zip: "43201",
    bedrooms: 1,
    bathrooms: 1,
    sqft: 650,
    currentRent: 950,
    baseRent: 950,
    securityDeposit: 1425,
    petsAllowed: true,
    amenities: ["Parking", "Laundry"],
    description: "Cozy 1-bedroom perfect for professionals",
  },
  {
    address: "321 Elm Street",
    city: "Columbus",
    state: "OH",
    zip: "43220",
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1100,
    currentRent: 1400,
    baseRent: 1400,
    securityDeposit: 2100,
    petsAllowed: true,
    amenities: ["Parking", "Laundry", "Dishwasher", "Air Conditioning"],
    description: "Modern 2-bedroom with updated kitchen",
  },
  {
    address: "654 Maple Drive",
    city: "Columbus",
    state: "OH",
    zip: "43214",
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2200,
    currentRent: 2200,
    baseRent: 2200,
    securityDeposit: 3300,
    petsAllowed: false,
    amenities: [
      "Parking",
      "Laundry",
      "Dishwasher",
      "Air Conditioning",
      "Gym",
      "Pool",
    ],
    description: "Luxury 4-bedroom family home",
  },
];

const streetNames = [
  "Main",
  "Oak",
  "Pine",
  "Elm",
  "Maple",
  "Cedar",
  "Birch",
  "Willow",
  "Spruce",
  "Park",
  "First",
  "Second",
  "Third",
  "Fourth",
  "Fifth",
];
const streetTypes = [
  "Street",
  "Avenue",
  "Drive",
  "Lane",
  "Road",
  "Court",
  "Circle",
  "Way",
];
const cities = ["Columbus", "Cleveland", "Cincinnati", "Toledo", "Akron"];
const states = ["OH", "OH", "OH", "OH", "OH"]; // All Ohio for consistency

export const getDebugUnits = (count = 5) => {
  const units = [];
  // Use 85% occupancy rate (more realistic for well-managed properties)
  const occupiedCount = Math.floor(count * 0.85);

  for (let i = 0; i < count; i++) {
    const template = baseUnitTemplates[i % baseUnitTemplates.length];
    const streetNum = 100 + i * 23;
    const streetName = streetNames[i % streetNames.length];
    const streetType = streetTypes[i % streetTypes.length];
    const city = cities[i % cities.length];
    const zip = `432${String(10 + (i % 90)).padStart(2, "0")}`;
    const isOccupied = i < occupiedCount;

    const rentAmount = template.currentRent + i * 25;
    units.push({
      id: `debug-unit-${i + 1}`,
      address: `${streetNum} ${streetName} ${streetType}`,
      city: city,
      state: states[i % states.length],
      zip: zip,
      bedrooms: template.bedrooms + (i % 2), // Vary bedrooms slightly
      bathrooms: template.bathrooms,
      sqft: template.sqft + i * 50,
      currentRent: rentAmount,
      monthlyRent: rentAmount, // Add monthlyRent for Units.jsx compatibility
      baseRent: template.baseRent + i * 25,
      securityDeposit: Math.round(rentAmount * 1.5),
      petsAllowed: i % 3 !== 0, // Mix of pet-friendly and not
      availableDate: isOccupied
        ? null
        : new Date(Date.now() + (i + 1) * 15 * 24 * 60 * 60 * 1000),
      photos: [],
      amenities: template.amenities,
      description: template.description,
      landlordId: "debug-landlord",
      tenantId: isOccupied ? `debug-tenant-${i + 1}` : null,
      createdAt: new Date(Date.now() - (180 - i * 10) * 24 * 60 * 60 * 1000),
      status: isOccupied ? "Occupied" : "Vacant", // Add status for Units.jsx
      name: `${streetNum} ${streetName} ${streetType}`, // Add name for Units.jsx
      unitNumber: `${Math.floor(i / 3) + 1}${String.fromCharCode(
        65 + (i % 3)
      )}`, // Add unitNumber for Units.jsx
    });
  }

  return units;
};

// Legacy function for backward compatibility
export const getDebugUnitsLegacy = () => {
  return [
    {
      id: "debug-unit-1",
      address: "123 Main Street",
      city: "Columbus",
      state: "OH",
      zip: "43215",
      bedrooms: 2,
      bathrooms: 1,
      sqft: 950,
      currentRent: 1200,
      baseRent: 1200,
      securityDeposit: 1800,
      petsAllowed: true,
      availableDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      photos: [],
      amenities: ["Parking", "Laundry", "Dishwasher"],
      description: "Beautiful 2-bedroom apartment in downtown Columbus",
      landlordId: "debug-landlord",
      createdAt: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-unit-2",
      address: "456 Oak Avenue",
      city: "Columbus",
      state: "OH",
      zip: "43210",
      bedrooms: 3,
      bathrooms: 2,
      sqft: 1400,
      currentRent: 1650,
      baseRent: 1650,
      securityDeposit: 2475,
      petsAllowed: false,
      availableDate: new Date(Date.now() + 45 * 24 * 60 * 60 * 1000),
      photos: [],
      amenities: [
        "Parking",
        "Laundry",
        "Dishwasher",
        "Air Conditioning",
        "Balcony",
      ],
      description: "Spacious 3-bedroom with modern amenities",
      landlordId: "debug-landlord",
      createdAt: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-unit-3",
      address: "789 Pine Street",
      city: "Columbus",
      state: "OH",
      zip: "43201",
      bedrooms: 1,
      bathrooms: 1,
      sqft: 650,
      currentRent: 950,
      baseRent: 950,
      securityDeposit: 1425,
      petsAllowed: true,
      availableDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
      photos: [],
      amenities: ["Parking", "Laundry"],
      description: "Cozy 1-bedroom perfect for professionals",
      landlordId: "debug-landlord",
      createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
    },
  ];
};

export const getDebugListings = (count = 2) => {
  // Generate listings for vacant units
  // Use a larger unit pool to ensure we have enough vacant units
  const unitPoolSize = Math.max(count * 2, 10); // At least 10 units to find vacant ones
  const units = getDebugUnits(unitPoolSize);
  const vacantUnits = units.filter((u) => !u.tenantId);
  const listings = [];

  // Use the first 'count' vacant units for listings
  const listingCount = Math.min(count, vacantUnits.length);
  for (let i = 0; i < listingCount; i++) {
    const unit = vacantUnits[i];
    if (!unit) continue;

    listings.push({
      id: `debug-listing-${i + 1}`,
      unitId: unit.id,
      landlordId: "debug-landlord",
      headline: `${unit.bedrooms} Bed, ${unit.bathrooms} Bath in ${unit.city}`,
      description: unit.description,
      listingType: "rent",
      rentAmount: unit.currentRent,
      deposit: unit.securityDeposit,
      bedrooms: unit.bedrooms,
      bathrooms: unit.bathrooms,
      sqft: unit.sqft,
      availableDate: unit.availableDate
        ? unit.availableDate.toISOString()
        : new Date().toISOString(),
      photos: [],
      amenities: unit.amenities,
      address: unit.address,
      city: unit.city,
      state: unit.state,
      zipCode: unit.zip,
      status: "active",
      viewCount: 100 + i * 50,
      inquiryCount: 5 + i * 3,
      rules: {
        petsAllowed: unit.petsAllowed,
        minCreditScore: 650 + i * 25,
        minIncomeMultiple: 2.5 + i * 0.2,
      },
      createdAt: new Date(
        Date.now() - (30 - i * 5) * 24 * 60 * 60 * 1000
      ).toISOString(),
      updatedAt: new Date().toISOString(),
    });
  }

  return listings;
};

// ============================================================================
// TENANTS DEBUG DATA
// ============================================================================

export const getDebugTenants = (unitCount = 5) => {
  // Base names for generating unique combinations
  const firstNames = [
    "Sarah",
    "Michael",
    "Emily",
    "David",
    "Jennifer",
    "Robert",
    "Lisa",
    "James",
    "Maria",
    "John",
    "Patricia",
    "Christopher",
    "Jessica",
    "Daniel",
    "Ashley",
    "Matthew",
    "Amanda",
    "Ryan",
    "Michelle",
    "Kevin",
    "Nicole",
    "Brian",
    "Stephanie",
    "Jason",
    "Melissa",
    "Eric",
    "Rebecca",
    "Justin",
    "Laura",
    "Brandon",
    "Kimberly",
    "Jonathan",
    "Amy",
    "Tyler",
    "Angela",
    "Jacob",
    "Rachel",
    "Nicholas",
    "Samantha",
    "Andrew",
    "Megan",
    "Joshua",
    "Heather",
    "Benjamin",
    "Christina",
    "Samuel",
    "Kelly",
    "Nathan",
    "Brittany",
    "Zachary",
    "Lauren",
    "Adam",
    "Stephanie",
    "Jordan",
    "Erin",
    "Noah",
    "Katherine",
    "Ethan",
    "Catherine",
    "Lucas",
    "Victoria",
    "Mason",
    "Olivia",
    "Logan",
    "Emma",
    "Aiden",
    "Sophia",
    "Carter",
    "Isabella",
    "Owen",
    "Mia",
    "Wyatt",
    "Charlotte",
    "Grayson",
    "Amelia",
    "Leo",
    "Harper",
    "Jack",
    "Evelyn",
    "Luke",
    "Abigail",
    "Henry",
    "Emily",
    "Alexander",
    "Madison",
    "Sebastian",
    "Chloe",
  ];

  const lastNames = [
    "Johnson",
    "Chen",
    "Rodriguez",
    "Martinez",
    "Lee",
    "Smith",
    "Wang",
    "Brown",
    "Garcia",
    "Williams",
    "Davis",
    "Miller",
    "Wilson",
    "Moore",
    "Taylor",
    "Anderson",
    "Thomas",
    "Jackson",
    "White",
    "Harris",
    "Martin",
    "Thompson",
    "Garcia",
    "Martinez",
    "Robinson",
    "Clark",
    "Rodriguez",
    "Lewis",
    "Walker",
    "Hall",
    "Allen",
    "Young",
    "King",
    "Wright",
    "Lopez",
    "Hill",
    "Scott",
    "Green",
    "Adams",
    "Baker",
    "Nelson",
    "Carter",
    "Mitchell",
    "Perez",
    "Roberts",
    "Turner",
    "Phillips",
    "Campbell",
    "Parker",
    "Evans",
    "Edwards",
    "Collins",
    "Stewart",
    "Sanchez",
    "Morris",
    "Rogers",
    "Reed",
    "Cook",
    "Morgan",
    "Bell",
    "Murphy",
    "Bailey",
    "Rivera",
    "Cooper",
    "Richardson",
    "Cox",
    "Howard",
    "Ward",
    "Torres",
    "Peterson",
    "Gray",
    "Ramirez",
    "James",
    "Watson",
    "Brooks",
    "Kelly",
    "Sanders",
    "Price",
    "Bennett",
    "Wood",
  ];

  // Generate units first to get the actual occupied units
  const units = getDebugUnits(unitCount);
  const occupiedUnits = units.filter((u) => u.tenantId);
  const tenantCount = occupiedUnits.length;
  const tenants = [];

  // Generate unique names by combining first and last names
  // Use a deterministic approach to ensure uniqueness
  for (let i = 0; i < tenantCount; i++) {
    const unit = occupiedUnits[i];
    // Cycle through first names, and cycle through last names independently
    // This ensures we get unique combinations like: Sarah Johnson, Michael Chen, Emily Rodriguez, etc.
    const firstNameIndex = i % firstNames.length;
    // Use a different pattern for last names to ensure variety
    // Alternate between different last name selection methods to avoid clustering
    const lastNameIndex =
      (i + Math.floor(i / firstNames.length)) % lastNames.length;
    const firstName = firstNames[firstNameIndex];
    const lastName = lastNames[lastNameIndex];

    // For very large counts, add a number suffix to ensure uniqueness
    const nameSuffix = Math.floor(i / (firstNames.length * lastNames.length));
    const fullLastName =
      nameSuffix > 0 ? `${lastName} ${nameSuffix + 1}` : lastName;

    const email = `${firstName.toLowerCase()}.${fullLastName
      .toLowerCase()
      .replace(/\s+/g, "")}${i}@email.com`;
    const phone = `(614) 555-${String(1000 + i).padStart(4, "0")}`;

    tenants.push({
      id: unit.tenantId, // Use the tenantId from the unit to ensure matching
      name: `${firstName} ${fullLastName}`,
      email: email,
      phone: phone,
      unitId: unit.id, // Match the unit ID exactly
      unitNumber: `${Math.floor(i / 3) + 1}${String.fromCharCode(
        65 + (i % 3)
      )}`,
      rentAmount: unit.currentRent, // Use actual unit rent amount
      monthlyRent: unit.currentRent, // Add monthlyRent for Units.jsx compatibility
      rentDueDay: 1 + (i % 5),
      moveInDate: new Date(Date.now() - (180 - i * 30) * 24 * 60 * 60 * 1000),
      leaseEndDate: new Date(Date.now() + (180 + i * 30) * 24 * 60 * 60 * 1000),
      status: "active",
      leaseStatus: "Active", // Add leaseStatus for Units.jsx occupied calculation
      hasPets: unit.petsAllowed && i % 2 === 0,
      emergencyContact: {
        name: `${
          firstNames[(firstNameIndex + 1) % firstNames.length]
        } ${fullLastName}`,
        phone: `(614) 555-${String(2000 + i).padStart(4, "0")}`,
        relationship:
          i % 3 === 0 ? "Spouse" : i % 3 === 1 ? "Sister" : "Father",
      },
      landlordId: "debug-landlord",
      createdAt: new Date(Date.now() - (180 - i * 30) * 24 * 60 * 60 * 1000),
    });
  }

  return tenants;
};

// Legacy function for backward compatibility
export const getDebugTenantsLegacy = () => {
  return [
    {
      id: "debug-tenant-1",
      name: "Sarah Johnson",
      email: "sarah.johnson@email.com",
      phone: "(614) 555-0123",
      unitId: "debug-unit-1",
      unitNumber: "1A",
      rentAmount: 1200,
      rentDueDay: 1,
      moveInDate: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000),
      leaseEndDate: new Date(Date.now() + 185 * 24 * 60 * 60 * 1000),
      status: "active",
      hasPets: true,
      emergencyContact: {
        name: "John Johnson",
        phone: "(614) 555-0124",
        relationship: "Spouse",
      },
      landlordId: "debug-landlord",
      createdAt: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-tenant-2",
      name: "Michael Chen",
      email: "michael.chen@email.com",
      phone: "(614) 555-0234",
      unitId: "debug-unit-2",
      unitNumber: "2B",
      rentAmount: 1650,
      rentDueDay: 1,
      moveInDate: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
      leaseEndDate: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
      status: "active",
      hasPets: false,
      emergencyContact: {
        name: "Lisa Chen",
        phone: "(614) 555-0235",
        relationship: "Sister",
      },
      landlordId: "debug-landlord",
      createdAt: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-tenant-3",
      name: "Emily Rodriguez",
      email: "emily.rodriguez@email.com",
      phone: "(614) 555-0345",
      unitId: "debug-unit-3",
      unitNumber: "3C",
      rentAmount: 950,
      rentDueDay: 5,
      moveInDate: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
      leaseEndDate: new Date(Date.now() + 275 * 24 * 60 * 60 * 1000),
      status: "active",
      hasPets: true,
      emergencyContact: {
        name: "Carlos Rodriguez",
        phone: "(614) 555-0346",
        relationship: "Father",
      },
      landlordId: "debug-landlord",
      createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
    },
  ];
};

// ============================================================================
// UNITS DEBUG DATA (Extended)
// ============================================================================

export const getDebugUnitsExtended = (count = 5) => {
  return getDebugUnits(count);
};

// Demo connect accounts for Settings: Primary + 2 LLCs (for ?debug=true&settings_demo=accounts|assets|both)
export const DEMO_CONNECT_ACCOUNT_IDS = {
  primary: "",
  llc1: "acct_llc1_demo",
  llc2: "acct_llc2_demo",
};

export const getDebugConnectAccounts = () => ({
  accounts: [
    {
      id: "primary",
      name: "Primary account",
      isPrimary: true,
      stripeConnectId: null,
      connectStatus: { charges_enabled: true },
    },
    {
      id: "llc-1",
      name: "Sunshine LLC",
      isPrimary: false,
      stripeConnectId: DEMO_CONNECT_ACCOUNT_IDS.llc1,
    },
    {
      id: "llc-2",
      name: "Riverside LLC",
      isPrimary: false,
      stripeConnectId: DEMO_CONNECT_ACCOUNT_IDS.llc2,
    },
  ],
});

// Units for Settings asset cards: same as getDebugUnits but with address object and stripeConnectIdOverride
// so some units show "Primary account" and some "Sunshine LLC" / "Riverside LLC"
export const getDebugSettingsUnits = (count = 5) => {
  const raw = getDebugUnits(count);
  const third = Math.max(1, Math.floor(count / 3));
  return raw.map((u, i) => {
    const stripeConnectIdOverride =
      i < third
        ? ""
        : i < 2 * third
        ? DEMO_CONNECT_ACCOUNT_IDS.llc1
        : DEMO_CONNECT_ACCOUNT_IDS.llc2;
    const street =
      typeof u.address === "string" ? u.address : u.address?.street || u.name;
    return {
      ...u,
      address:
        typeof u.address === "object" && u.address
          ? {
              ...u.address,
              zipCode: u.address.zipCode || u.address.zip || u.zip,
            }
          : {
              street: street || u.name,
              city: u.city,
              state: u.state,
              zipCode: u.zip,
            },
      stripeConnectIdOverride: stripeConnectIdOverride || undefined,
    };
  });
};

// Legacy extended units
export const getDebugUnitsExtendedLegacy = () => {
  return [
    ...getDebugUnitsLegacy(),
    {
      id: "debug-unit-4",
      address: "321 Elm Street",
      city: "Columbus",
      state: "OH",
      zip: "43220",
      bedrooms: 2,
      bathrooms: 2,
      sqft: 1100,
      currentRent: 1400,
      baseRent: 1400,
      securityDeposit: 2100,
      petsAllowed: true,
      availableDate: null, // Currently occupied
      photos: [],
      amenities: ["Parking", "Laundry", "Dishwasher", "Air Conditioning"],
      description: "Modern 2-bedroom with updated kitchen",
      landlordId: "debug-landlord",
      tenantId: "debug-tenant-1",
      createdAt: new Date(Date.now() - 200 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-unit-5",
      address: "654 Maple Drive",
      city: "Columbus",
      state: "OH",
      zip: "43214",
      bedrooms: 4,
      bathrooms: 3,
      sqft: 2200,
      currentRent: 2200,
      baseRent: 2200,
      securityDeposit: 3300,
      petsAllowed: false,
      availableDate: null, // Currently occupied
      photos: [],
      amenities: [
        "Parking",
        "Laundry",
        "Dishwasher",
        "Air Conditioning",
        "Gym",
        "Pool",
      ],
      description: "Luxury 4-bedroom family home",
      landlordId: "debug-landlord",
      tenantId: "debug-tenant-2",
      createdAt: new Date(Date.now() - 150 * 24 * 60 * 60 * 1000),
    },
  ];
};

// ============================================================================
// LEASES DEBUG DATA
// ============================================================================

export const getDebugLeases = (unitCount = 5) => {
  // Get tenants that match the actual occupied units
  const tenants = getDebugTenants(unitCount);
  const units = getDebugUnits(unitCount);
  const leases = [];

  // Active leases - match tenants to their units
  for (let i = 0; i < tenants.length; i++) {
    const tenant = tenants[i];
    const unit = units.find((u) => u.id === tenant.unitId);
    if (!unit) continue; // Skip if unit not found

    leases.push({
      id: `debug-lease-${i + 1}`,
      unitId: unit.id,
      tenantId: tenant.id,
      landlordId: "debug-landlord",
      startDate: tenant.moveInDate,
      endDate: tenant.leaseEndDate,
      rentAmount: tenant.rentAmount,
      securityDeposit: unit.securityDeposit,
      status: "active",
      documentUrl: null,
      createdAt: tenant.moveInDate,
    });
  }

  // Add some expired leases for vacant units
  const vacantUnits = units.filter((u) => !u.tenantId);
  const expiredCount = Math.min(
    Math.floor(unitCount * 0.2),
    vacantUnits.length
  ); // 20% expired leases
  for (let i = 0; i < expiredCount; i++) {
    const unit = vacantUnits[i];
    if (!unit) continue;
    leases.push({
      id: `debug-lease-expired-${i + 1}`,
      unitId: unit.id,
      tenantId: null,
      landlordId: "debug-landlord",
      startDate: new Date(Date.now() - (730 - i * 30) * 24 * 60 * 60 * 1000),
      endDate: new Date(Date.now() - (30 - i * 10) * 24 * 60 * 60 * 1000),
      rentAmount: unit.currentRent,
      securityDeposit: unit.securityDeposit,
      status: "expired",
      documentUrl: null,
      createdAt: new Date(Date.now() - (730 - i * 30) * 24 * 60 * 60 * 1000),
    });
  }

  return leases;
};

// Legacy function
export const getDebugLeasesLegacy = () => {
  return [
    {
      id: "debug-lease-1",
      unitId: "debug-unit-1",
      tenantId: "debug-tenant-1",
      landlordId: "debug-landlord",
      startDate: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000),
      endDate: new Date(Date.now() + 185 * 24 * 60 * 60 * 1000),
      rentAmount: 1200,
      securityDeposit: 1800,
      status: "active",
      documentUrl: null,
      createdAt: new Date(Date.now() - 180 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-lease-2",
      unitId: "debug-unit-2",
      tenantId: "debug-tenant-2",
      landlordId: "debug-landlord",
      startDate: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
      endDate: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
      rentAmount: 1650,
      securityDeposit: 2475,
      status: "active",
      documentUrl: null,
      createdAt: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-lease-3",
      unitId: "debug-unit-3",
      tenantId: "debug-tenant-3",
      landlordId: "debug-landlord",
      startDate: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
      endDate: new Date(Date.now() + 275 * 24 * 60 * 60 * 1000),
      rentAmount: 950,
      securityDeposit: 1425,
      status: "active",
      documentUrl: null,
      createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
    },
    {
      id: "debug-lease-4",
      unitId: "debug-unit-4",
      tenantId: null,
      landlordId: "debug-landlord",
      startDate: new Date(Date.now() - 730 * 24 * 60 * 60 * 1000),
      endDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000),
      rentAmount: 1400,
      securityDeposit: 2100,
      status: "expired",
      documentUrl: null,
      createdAt: new Date(Date.now() - 730 * 24 * 60 * 60 * 1000),
    },
  ];
};

// ============================================================================
// DASHBOARD STATS DEBUG DATA
// ============================================================================

export const getDebugDashboardStats = (unitCount = 5) => {
  // Use actual unit data to calculate accurate stats
  const units = getDebugUnits(unitCount);
  const occupiedUnits = units.filter((u) => u.tenantId);
  const occupiedCount = occupiedUnits.length;
  const vacantUnits = unitCount - occupiedCount;

  // Calculate actual total monthly rent from occupied units
  const totalMonthlyRent = occupiedUnits.reduce(
    (sum, unit) => sum + unit.currentRent,
    0
  );
  const collectionRate = 0.85; // 85% collection rate

  return {
    totalUnits: unitCount,
    occupiedUnits: occupiedCount,
    vacantUnits: vacantUnits,
    occupancyRate: occupiedCount / unitCount,
    totalMonthlyRent: totalMonthlyRent,
    collectedThisMonth: Math.round(totalMonthlyRent * collectionRate),
    pendingThisMonth: Math.round(totalMonthlyRent * (1 - collectionRate) * 0.7),
    overdueAmount: Math.round(totalMonthlyRent * (1 - collectionRate) * 0.3),
    activeLeases: occupiedCount,
    expiringSoon: Math.max(1, Math.floor(occupiedCount * 0.2)),
    activeRepairs: Math.max(1, Math.floor(unitCount * 0.3)),
    completedRepairsThisMonth: Math.max(3, Math.floor(unitCount * 0.8)),
    totalTenants: occupiedCount,
    newInquiries: Math.max(2, Math.floor(vacantUnits * 2.5)),
    activeListings: vacantUnits,
  };
};

// ============================================================================
// RENT DASHBOARD DEBUG DATA (Extended)
// ============================================================================

export const getDebugPayments = (unitCount = 5) => {
  const paymentDate = new Date();
  const paymentMonth = paymentDate.getMonth();
  const paymentYear = paymentDate.getFullYear();
  // Get tenants that match the actual occupied units
  const tenants = getDebugTenants(unitCount);
  const payments = [];

  // Generate payments for each tenant
  // In debug mode, mark all payments as paid for clean screenshots
  tenants.forEach((tenant, i) => {
    // All payments are marked as paid in debug mode
    const status = "paid";
    const paidDate = new Date(paymentYear, paymentMonth, tenant.rentDueDay);
    const paymentMethod = i % 2 === 0 ? "card" : "bank_transfer";

    // Current month payment
    payments.push({
      id: `debug-payment-${i * 3 + 1}`,
      tenantId: tenant.id,
      tenantName: tenant.name,
      unitId: tenant.unitId,
      unitNumber: tenant.unitNumber,
      amount: tenant.rentAmount, // Use actual tenant rent amount (from unit)
      dueDate: new Date(paymentYear, paymentMonth, tenant.rentDueDay),
      status: status,
      paidDate: paidDate,
      paymentMethod: paymentMethod,
      landlordId: "debug-landlord",
      createdAt: new Date(paymentYear, paymentMonth - 1, 25),
    });

    // Next month payment (also marked as paid for consistency)
    payments.push({
      id: `debug-payment-${i * 3 + 2}`,
      tenantId: tenant.id,
      tenantName: tenant.name,
      unitId: tenant.unitId,
      unitNumber: tenant.unitNumber,
      amount: tenant.rentAmount, // Use actual tenant rent amount (from unit)
      dueDate: new Date(paymentYear, paymentMonth + 1, tenant.rentDueDay),
      status: "paid",
      paidDate: new Date(paymentYear, paymentMonth + 1, tenant.rentDueDay),
      paymentMethod: paymentMethod,
      landlordId: "debug-landlord",
      createdAt: new Date(paymentYear, paymentMonth, 25),
    });

    // Previous month payment
    payments.push({
      id: `debug-payment-${i * 3 + 3}`,
      tenantId: tenant.id,
      tenantName: tenant.name,
      unitId: tenant.unitId,
      unitNumber: tenant.unitNumber,
      amount: tenant.rentAmount, // Use actual tenant rent amount (from unit)
      dueDate: new Date(paymentYear, paymentMonth - 1, tenant.rentDueDay),
      status: "paid",
      paidDate: new Date(paymentYear, paymentMonth - 1, tenant.rentDueDay + 1),
      paymentMethod: i % 2 === 0 ? "card" : "bank_transfer",
      landlordId: "debug-landlord",
      createdAt: new Date(paymentYear, paymentMonth - 2, 28),
    });
  });

  // Calculate summary stats correctly
  // Current month payments (what's due this month)
  const currentMonthPayments = payments.filter((p) => {
    const dueDate = new Date(p.dueDate);
    return (
      dueDate.getMonth() === paymentMonth &&
      dueDate.getFullYear() === paymentYear
    );
  });

  // All payments are paid in debug mode
  const totalPaid = payments
    .filter((p) => p.status === "paid")
    .reduce((sum, p) => sum + p.amount, 0);
  const totalPending = 0; // No pending payments in debug mode
  const totalOverdue = 0; // No overdue payments in debug mode

  // Total rent due = sum of all current month payments
  const totalRentDue = currentMonthPayments.reduce(
    (sum, p) => sum + p.amount,
    0
  );

  // Collected = all current month payments (since all are paid)
  const collectedThisMonth = currentMonthPayments.reduce(
    (sum, p) => sum + p.amount,
    0
  );

  return {
    payments: payments,
    summary: {
      totalDue: totalRentDue, // Total rent due for current month
      totalPaid: collectedThisMonth, // Collected this month (all payments are paid)
      totalPending: totalPending, // No pending payments in debug mode
      totalOverdue: totalOverdue, // No overdue payments in debug mode
      paidCount: payments.length, // All payments are paid
      pendingCount: 0, // No pending payments
      overdueCount: 0, // No overdue payments
    },
  };
};
